@if (inEditorMode()) {
  <span class="fw-bold">{{ field().settings?.label }}</span>
} @else {
  <div
    class="section-summary-container p-3 d-flex align-items-center justify-content-between"
  >
    <div class="d-flex align-items-center">
      <ng-icon
        [name]="fieldType().icon"
        size="1.125rem"
      />

      <span class="fw-bold ms-2">{{ field().settings?.label }}</span>
    </div>

    <span class="fw-bold">{{ score | scoreFormat }}</span>
  </div>
}
